module.exports = __webpack_public_path__ + "img/us.7e035538.svg";